import './BodySmallText.scss';
import clsx from 'clsx';
import React from 'react';

type Props = {
  className?: string;
  children: React.ReactNode;
};

export const BodySmallText = ({ className, children }: Props): React.ReactElement => (
  <p className={clsx('bp-body-small-text', className)}>
    {children}
  </p>
);
